import { __extends } from "tslib";
import { BBox as BBoxBase } from '@antv/g2/lib/util/bbox';
export { DIRECTION } from '@antv/g2/lib/constant';
var BBox = /** @class */ (function (_super) {
    __extends(BBox, _super);
    function BBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BBox.fromBBoxObject = function (bbox) {
        return new BBox(bbox.x, bbox.y, bbox.width, bbox.height);
    };
    return BBox;
}(BBoxBase));
export default BBox;
//# sourceMappingURL=bbox.js.map